// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3hGYA","image":"Header_image__dx92D","name":"Header_name__2uYb9","info":"Header_info__1jiEW","infoRow":"Header_infoRow__3kYOa"};